import { render } from "./ErrorPage.vue?vue&type=template&id=351a5656&scoped=true&ts=true"
import script from "./ErrorPage.vue?vue&type=script&lang=ts"
export * from "./ErrorPage.vue?vue&type=script&lang=ts"

import "./ErrorPage.vue?vue&type=style&index=0&id=351a5656&scoped=true&lang=scss"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351a5656"]])

export default __exports__